export default "__VITE_ASSET__ded02a02__"